/**
 * Creates Slick Slider on .js-info-cards when viewport is ≤ 767px,
 * and destroys it (unslick) above that viewport.
 */
(function () {
    function initInfoCardsSlider() {
        var $grid = $('.js-info-cards');

        if (window.innerWidth <= 767) {
            if (!$grid.hasClass('slick-initialized')) {
                $grid.slick({
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: false,
                    dots: true,
                });
            }
        } else {
            if ($grid.hasClass('slick-initialized')) {
                $grid.slick('unslick');
            }
        }
    }

    // initialize on resize too
    $(document).ready(initInfoCardsSlider);
    $(window).on('resize', initInfoCardsSlider);
})();
